import { createContext, useContext, useMemo, useState } from "react";

const LanguageContext = createContext(null);

const copy = {
  en: {
    navigation: {
      students: "Students",
      recruiters: "Recruiters",
      courses: "Courses",
      gallery: "Gallery",
      collaboration: "Collaborate",
      about: "About Us",
      programs: "Programs",
      canadian: "Canadian Collaboration",
      testimonials: "Testimonials",
      certifications: "Certifications",
      enroll: "Enroll Now",
      lms: "Student Login",
      admin: "Admin",
      enroll: "Enroll now",
    },
    footer: "Begin your journey",
    home: {
      eyebrow: "TRAINING FOR THE REAL WORLD",
      headingFirst: "Build skills that",
      headingEmphasis: "move you forward.",
      description: "Hands-on training. Recognised certificates. A confident next step.",
      action: "Find your course",
      explore: "Explore",
      why: "01 / WHY MSDC",
      outcomes: "Training that starts with doing.",
      outcomesBody: "We put tools in your hands, mentors beside you, and your future within reach. Every course is built around practical capability.",
      students: "learners equipped",
      pathways: "practical pathways",
      focus: "hands-on focus",
      path: "A PATH THAT FITS",
      nextFirst: "Your next skill",
      nextSecond: "starts here.",
      exploreCourses: "Explore all courses",
      community: "IN THE COMMUNITY",
      sharedFirst: "Learning is better",
      sharedSecond: "when it’s shared.",
      events: "See our events",
    },
    courses: {
      eyebrow: "CHOOSE YOUR DIRECTION",
      headingFirst: "Practical learning.",
      headingEmphasis: "Clear outcomes.",
      intro: "Industry-informed training designed to turn your motivation into valuable, visible skills.",
      loading: "Loading courses…",
    },
    gallery: {
      eyebrow: "THE MSDC NOTEBOOK",
      headingFirst: "Made in the",
      headingEmphasis: "moment.",
      allEvents: "All events",
      loading: "Loading event moments…",
    },
  },
  hi: {
    navigation: {
      students: "विद्यार्थी",
      recruiters: "नियोक्ता",
      courses: "कोर्स",
      gallery: "गैलरी",
      collaboration: "सहयोग",
      about: "हमारे बारे में",
      programs: "कार्यक्रम",
      canadian: "कनाडाई सहयोग",
      testimonials: "प्रशंसापत्र",
      certifications: "प्रमाणपत्र",
      enroll: "नामांकन करें",
      lms: "छात्र लॉगिन",
      admin: "एडमिन",
      enroll: "अभी नामांकन करें",
    },
    footer: "अपनी यात्रा शुरू करें",
    home: {
      eyebrow: "वास्तविक दुनिया के लिए प्रशिक्षण",
      headingFirst: "ऐसे कौशल बनाइए जो",
      headingEmphasis: "आपको आगे बढ़ाएँ।",
      description: "व्यावहारिक प्रशिक्षण। मान्य प्रमाणपत्र। आपके अगले कदम के लिए आत्मविश्वास।",
      action: "अपना कोर्स खोजें",
      explore: "जानें",
      why: "01 / MSDC क्यों",
      outcomes: "प्रशिक्षण जो करके सीखने से शुरू होता है।",
      outcomesBody: "हम आपके हाथों में उपकरण, साथ में मार्गदर्शक और आपके भविष्य तक पहुँच देते हैं। हर कोर्स व्यावहारिक क्षमता पर आधारित है।",
      students: "प्रशिक्षित विद्यार्थी",
      pathways: "व्यावहारिक मार्ग",
      focus: "हैंड्स-ऑन फोकस",
      path: "आपके लिए सही रास्ता",
      nextFirst: "आपका अगला कौशल",
      nextSecond: "यहीं से शुरू होता है।",
      exploreCourses: "सभी कोर्स देखें",
      community: "समुदाय में",
      sharedFirst: "सीखना बेहतर है",
      sharedSecond: "जब इसे साथ साझा किया जाए।",
      events: "हमारे कार्यक्रम देखें",
    },
    courses: {
      eyebrow: "अपनी दिशा चुनें",
      headingFirst: "व्यावहारिक शिक्षा।",
      headingEmphasis: "स्पष्ट परिणाम।",
      intro: "उद्योग-अनुकूल प्रशिक्षण जो आपकी प्रेरणा को मूल्यवान और उपयोगी कौशल में बदलता है।",
      loading: "कोर्स लोड हो रहे हैं…",
    },
    gallery: {
      eyebrow: "MSDC की झलकियाँ",
      headingFirst: "यादगार",
      headingEmphasis: "पल।",
      allEvents: "सभी कार्यक्रम",
      loading: "कार्यक्रम के पल लोड हो रहे हैं…",
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem("msdc-language") || "en");
  const toggleLanguage = () => {
    const nextLanguage = language === "en" ? "hi" : "en";
    localStorage.setItem("msdc-language", nextLanguage);
    setLanguage(nextLanguage);
  };
  const value = useMemo(() => ({ language, toggleLanguage, copy: copy[language] }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);